import { Box } from "@mui/material";
import { forwardRef, useEffect, useMemo, useState } from "react";
import { useJiraQueries } from "../hooks/useJiraQueries";
import JiraProjectName from "./fields/JiraProjectName";
import JiraTicketForm from "./JiraTicketForm";
import JSMTicketForm from "./JSMTicketFrom";

const JSM_PROJECT_TYPE = "service_desk";
export const JIRA_FORM_WIDTH = "450px";

const JiraFormSelector = forwardRef(
  (
    {
      setIsFormReady,
      fullControl,
      issueAutoGeneratedFields,
      onSubmitJira,
      onSubmitJSM,
    },
    ref
  ) => {
    const [selectedProject, setSelectedProject] = useState(null);

    const { projectOptions, projectOptionsIsSuccess } =
      useJiraQueries(selectedProject);

    useEffect(() => {
      // The form is ready when a project is selected.
      setIsFormReady(!!selectedProject);
    }, [selectedProject]);

    const isJSMProject = useMemo(() => {
      return selectedProject?.projectTypeKey === JSM_PROJECT_TYPE;
    }, [selectedProject]);

    const selectedForm = useMemo(() => {
      if (!selectedProject) {
        return null;
      }

      if (isJSMProject) {
        return (
          <JSMTicketForm
            ref={ref}
            key={selectedProject.key}
            fullControl={fullControl}
            selectedProject={selectedProject}
            issueAutoGeneratedFields={issueAutoGeneratedFields}
            onSubmit={onSubmitJSM}
          />
        );
      }

      return (
        <JiraTicketForm
          ref={ref}
          key={selectedProject.key}
          fullControl={fullControl}
          selectedProject={selectedProject}
          issueAutoGeneratedFields={issueAutoGeneratedFields}
          onSubmit={onSubmitJira}
        />
      );
    }, [selectedProject, ref]);

    return (
      <Box sx={{ width: JIRA_FORM_WIDTH, height: "720px" }}>
        <Box sx={{ mb: 2 }}>
          <JiraProjectName
            options={projectOptions}
            showOptions={projectOptionsIsSuccess}
            selectedOption={selectedProject}
            setSelectedOption={setSelectedProject}
          />
        </Box>
        {selectedForm}
      </Box>
    );
  }
);

export default JiraFormSelector;
